import ApplicationAdapter from "./application";

export default class InstanceUserAdapter extends ApplicationAdapter {
  urlForDeleteRecord(id: string): string {
    return `${this.apiBaseUri}/database/deleteuser?userid=${id}`;
  }
}
